import get from 'lodash/get'
import Vue from 'vue'

Vue.mixin({
  methods: {
    $get: (obj, path, defaultValue) => get(obj, path, defaultValue)
  }
});
